import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT, systemFeatures } from '../data/content';
export function SystemSection() {
  return <section aria-labelledby="sistema" className="bg-night" data-id="element-198" data-mp="3bkpxes2p4goe">
      <div className="mx-auto max-w-page px-3 py-8 sm:px-6 sm:py-10" data-id="element-199" data-mp="36j0iv2g9lkvk">
        <Reveal className="text-center" data-id="element-200" data-mp="31l8ugietwgw4">
          <p className="text-[0.65rem] font-extrabold uppercase tracking-[0.24em] text-volt sm:text-xs" data-id="element-201" data-mp="31ma88un8bhhj">
            El sistema completo 6 en 1
          </p>
          <h2 id="sistema" className="mt-1 font-display text-xl uppercase leading-[1.08] text-volt sm:text-3xl lg:text-4xl" data-id="element-202" data-mp="2srvskqyse4xw">
            ⚡ {PRODUCT}
          </h2>
          <p className="mt-1 text-[0.75rem] font-extrabold uppercase tracking-[0.14em] text-white sm:text-sm" data-id="element-203" data-mp="2iur24exwrnba">
            Formación inicial visual y práctica para principiantes
          </p>
        </Reveal>

        <div className="mt-5 grid items-center gap-5 lg:grid-cols-[1.1fr_1fr]" data-id="element-204" data-mp="13yy4fd04rzg0">
          <Reveal delay={0.04} data-id="element-205" data-mp="18pof95rbsui3">
            <a href={OFFER_ANCHOR} className="block" data-id="element-206" data-mp="18qq1859vr1el">
              <img src={PACK_IMAGE} alt={`Contenido incluido en ${PRODUCT}`} className="mx-auto w-full max-w-lg rounded-xl" data-id="element-207" data-mp="u11v8qqr7ekj" />
            </a>
          </Reveal>

          <Reveal delay={0.08} data-id="element-208" data-mp="1mpfwdfd52r0b">
            <ul className="grid gap-2" data-id="element-209" data-mp="1mq8ujry1886u">
              {systemFeatures.map(feature => <li key={feature} className="flex items-center gap-2 rounded-lg border-l-4 border-volt bg-carbon px-3 py-2.5 text-[0.82rem] font-bold uppercase text-white sm:text-sm" data-id="element-210" data-mp="1rnhcpsj6kc83">
                  <CheckIcon size={16} className="flex-shrink-0 text-volt" strokeWidth={3} data-id="element-211" data-mp="1hsfnkwowna5i" />
                  {feature}
                </li>)}
            </ul>
            <div className="mt-4 flex justify-center lg:justify-start" data-id="element-212" data-mp="28wtfhn2pzqw0">
              <CtaButton data-id="element-213" data-mp="23yi77gs2pofw">OBTÉN EL SISTEMA COMPLETO HOY</CtaButton>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}